import React, { PropsWithChildren, useState } from 'react';
import { Checkbox, Button, Modal } from 'rsuite';

interface TermsModalProps {
  isLoading?: boolean;
  onAcceptTerms: () => void;
  onDeclineTerms: () => void;
  open: boolean;
  title: string;
}

const TermsModal: React.FC<PropsWithChildren<TermsModalProps>> = ({
  children,
  isLoading,
  onAcceptTerms,
  onDeclineTerms,
  open,
  title,
}) => {
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState(false);

  const handleOk = () => {
    if (!checked) {
      setError(true);
    } else {
      setError(false);
      onAcceptTerms();
    }
  };

  return (
    <Modal
      aria-labelledby="terms-modal"
      open={open}
      onClose={onDeclineTerms}
      backdrop
    >
      <label
        id="terms-modal"
        className="sr-only"
      >
        terms-modal
      </label>
      <div
        style={{ margin: '0 auto', position: 'relative', padding: '0 16px' }}
      >
        <div
          style={{
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: 20,
            padding: '16px 0',
          }}
        >
          {title}
        </div>
        <div>{children}</div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 8,
            marginTop: '16px',
          }}
        >
          <div style={{ alignSelf: 'center' }}>
            <Checkbox
              checked={checked}
              onChange={(_, checked) => setChecked(checked)}
            >
              I agree to the Terms of Service and Privacy Policy
            </Checkbox>
          </div>
          {error && (
            <div
              style={{
                color: 'red',
                fontSize: 14,
                alignSelf: 'center',
              }}
            >
              You must agree to the Terms of Service and Privacy Policy
            </div>
          )}
          <div style={{ alignSelf: 'center', display: 'flex', gap: 8 }}>
            <Button
              disabled={isLoading}
              className="btn-primary mv-4"
              onClick={handleOk}
            >
              OK
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TermsModal;
